module.exports = __webpack_public_path__ + "static/media/smog1_noloop.f1cfe585.mp4";